import { useTranslation } from "react-i18next";
import ReactTooltip from "react-tooltip";

import { useUIStateStore } from "@/store/uiStateStore";

import useGetColours from "../helpers/getColours";

type GigsPillProps = {
  gigStatus: number | null;
};

type PillState = {
  colours?: {
    backgroundColor: string;
  };
  status: string;
  classes: string;
  tooltip: string;
};

// use classes object if future catalogues need different styling
function GigsPill({ gigStatus }: GigsPillProps) {
  const { t } = useTranslation("gigs");

  const { statusSuccessColour, statusWarningColour, statusErrorColour } = useGetColours();

  const isTunecore = useUIStateStore(state => state.isTunecore);
  const styles = isTunecore
    ? { textColor: "black", backgroundColor: "#00ef86" }
    : {};
  let obj: PillState = {
    colours: undefined,
    status: "",
    classes: "",
    tooltip: "",
  };

  if (gigStatus === 1) {
    obj = {
      colours: {
        backgroundColor: statusWarningColour,
      },
      status: t("gigs:pill-not-verified"),
      classes: "",
      tooltip: "",
    };
  }
  if (gigStatus === 2 || gigStatus === 3 || gigStatus === 6) {
    obj = {
      colours: {
        backgroundColor: statusSuccessColour,
      },
      status: t("gigs:pill-processed"),
      classes: "",
      tooltip: "",
    };
  }
  if (gigStatus === 4) {
    obj = {
      colours: {
        backgroundColor: statusErrorColour,
      },
      status: t("gigs:pill-ineligible"),
      classes: "",
      tooltip: "",
    };
  }
  if (gigStatus === 5) {
    obj = {
      colours: {
        backgroundColor: statusErrorColour,
      },
      status: t("gigs:pill-rejected"),
      classes: "",
      tooltip: "",
    };
  }
  if (gigStatus === 7) {
    obj = {
      colours: {
        backgroundColor: statusSuccessColour,
      },
      status: t("gigs:pill-archived"),
      classes: "",
      tooltip: "",
    };
  }
  return (
    <div className="tooltip-with-edit-icon-container">
      <ReactTooltip effect="solid" multiline {...styles} />
      <div
        style={obj.colours}
        data-tip={obj.tooltip}
        className={`inline-block text-white text-xxs text-center py-2 px-5 rounded-lg uppercase ${obj.classes}`}
      >
        {obj.status}
      </div>
    </div>
  );
}

export default GigsPill;
